<template>
  <v-row>
    <v-btn
      v-if="first !== true"
      @click="previous"
    >
      <v-icon>mdi-arrow-up-thick</v-icon>
      戻る
    </v-btn>
    <v-btn
      v-if="last !== true"
      color="primary"
      @click="next"
    >
      <v-icon>mdi-arrow-down-thick</v-icon>
      次へ
    </v-btn>
    <v-spacer />
    <!-- DLボタン -->
    <v-btn
      color="primary"
      @click="clickDl"
    >
      <v-icon>mdi-download</v-icon>
      辞書データDL
    </v-btn>
  </v-row>
</template>

<script>
  export default {
    name: 'StepperNavi',
    components: {
    },
    props: {
      step: {
        type: Number,
        required: true,
      },
      first: {
        type: Boolean,
        required: false,
      },
      last: {
        type: Boolean,
        required: false,
      },
    },
    methods: {
      previous: function () {
        this.$emit('step', this.step - 1)
      },
      next: function () {
        this.$emit('step', this.step + 1)
      },
      clickDl: function () {
        this.$emit('clickDl')
      },
    },
  }
</script>
